import {Component, Input} from '@angular/core';
import {AmountPipe, EmTranslatePipe} from '@emma-labs/shared/angular';
import {TextTranslations} from '@emma-labs/shared/typescript';
import {DividerModule} from 'primeng/divider';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ProtectionSummary, RiderSummary} from '../../entities/underwriting-page-object/profile-info';

@Component({
  selector: 'em-protection-summary',
  templateUrl: './protection-summary.component.html',
  imports: [DividerModule, ProgressSpinnerModule, EmTranslatePipe, AmountPipe],
})
export class ProtectionSummaryComponent {
  baseInsurance!: {description: TextTranslations; coverage: number; price: number};
  riders?: RiderSummary[];
  totalPrice = 0;

  @Input({required: true}) set protectionSummary(protection: ProtectionSummary) {
    this.baseInsurance = protection.baseInsurance;
    this.riders = protection.riders;
    this.totalPrice =
      this.baseInsurance.price +
      (this.riders?.reduce((acc, rider) => acc + (rider.isRemoved ? 0 : rider.price), 0) || 0);
  }

  @Input() title: string | undefined;
  @Input() isUpdatingSurcharge = false;
}
